import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Portfolio", to: "/#portfolio" },
  { label: "Practice", to: "/#practice" },
  { label: "About", to: "/#team" },
  { label: "Enquire", to: "/#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else navigate(to);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-background/80 backdrop-blur-xl border-border" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo" className="font-display text-lg font-extrabold tracking-tight">
          RUBINO<span className="font-light"> Real Estate</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.label}
              data-testid={`nav-${n.label.toLowerCase()}`}
              onClick={() => go(n.to)}
              className="text-sm link-underline"
            >
              {n.label}
            </button>
          ))}
          {user ? (
            <button data-testid="nav-admin" onClick={() => navigate("/admin")} className="overline">Dashboard</button>
          ) : null}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-background border-b border-border px-6 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <button key={n.label} onClick={() => go(n.to)} className="text-left text-lg font-display">
              {n.label}
            </button>
          ))}
          {user && <button onClick={() => { setOpen(false); navigate("/admin"); }} className="text-left overline">Dashboard</button>}
        </div>
      )}
    </header>
  );
}
